const widgets = new Map();

function renderOrderCaptchas() {
  if (!window.turnstile || document.documentElement.hasAttribute('data-turbolinks-preview')) return;

  document.querySelectorAll('[data-order-captcha]').forEach((element) => {
    if (widgets.has(element)) return;

    const status = element.parentElement.querySelector('[data-captcha-status]');
    const widget = window.turnstile.render(element, {
      sitekey: element.dataset.sitekey,
      action: element.dataset.action,
      language: 'nl',
      callback: () => { status.textContent = ''; },
      'expired-callback': () => {
        status.textContent = 'De veiligheidscontrole is verlopen. Voltooi de controle opnieuw.';
      },
      'error-callback': () => {
        status.textContent = 'De veiligheidscontrole kon niet worden geladen. Vernieuw de pagina om opnieuw te proberen.';
      }
    });
    widgets.set(element, widget);
  });
}

window.renderOrderCaptchas = renderOrderCaptchas;

document.addEventListener('turbolinks:load', () => {
  if (!document.querySelector('[data-order-captcha]')) return;
  if (window.turnstile) return renderOrderCaptchas();
  if (document.getElementById('order-captcha-script')) return;

  const script = document.createElement('script');
  script.id = 'order-captcha-script';
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=renderOrderCaptchas';
  script.async = true;
  script.onerror = () => {
    document.querySelectorAll('[data-captcha-status]').forEach((status) => {
      status.textContent = 'De veiligheidscontrole kon niet worden geladen. Vernieuw de pagina om opnieuw te proberen.';
    });
    script.remove();
  };
  document.head.appendChild(script);
});

document.addEventListener('turbolinks:before-cache', () => {
  widgets.forEach((widget) => window.turnstile.remove(widget));
  widgets.clear();
});
